import React, { useEffect, useRef, useState } from 'react';

/**
 * StoryImage — an <img> that fades in once it has loaded. Callers key it per
 * slide so it remounts between stories; either way a src change hides the old
 * bitmap first (so a previous slide's poster never lingers under new content)
 * and the new image fades in when ready. The `complete` check covers cached
 * images that finish loading before React attaches the onLoad listener.
 */
export default function StoryImage({ src, alt = '', className = '', ...rest }) {
    const imgRef = useRef(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(false);
        const img = imgRef.current;
        if (img && img.complete && img.naturalWidth > 0) {
            setLoaded(true);
        }
    }, [src]);

    return (
        <img
            ref={imgRef}
            src={src}
            alt={alt}
            onLoad={() => setLoaded(true)}
            className={`${className} transition-opacity duration-200 ${loaded ? 'opacity-100' : 'opacity-0'}`}
            {...rest}
        />
    );
}
